/* eslint-disable  @typescript-eslint/no-explicit-any */

import { AxiosError } from 'axios';
import React, { useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { hr, reload } from '../../assets/images/login';
import { wqkgx } from '../../config/keys';
import { Colors, timeout } from '../../utils/constants';
import { handleError } from '../../utils/errorHandler';
import CryptoJS from 'crypto-js';
import { encryptData } from '../../utils/encryptJson';
import { decryptJson } from '../../utils/decryptJson';
import { logUserOut } from '../../utils/logUserOut';
import useOnSuccessfulLogin from '../../hooks/useOnSuccessfulLogin';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import jwtDecode from 'jwt-decode';
import ReactGA from 'react-ga4';
import { getOtpBottomText, getOtpText } from '../../utils/getOtpText';
import { ClipLoader } from 'react-spinners';
import OtpInput from './OtpInput';
import customToast, { ToastType } from '../../components_/Toast';
import { Request } from '../../apis/request';
import Countdown from '../../features/authentication/OtpCountdown';
import { Flex, Text } from '@chakra-ui/react';

type TProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  phoneNumber?: string;
  pageComingFrom: 'Signup' | 'Login';
  email?: string;
  showUnverifiedPhoneModal?: () => void;
};
export default function OtpModal({
  showModal,
  setShowModal,
  setShowSuccessModal,
  email,
  phoneNumber,
  showUnverifiedPhoneModal = () => {
    return;
  },
}: TProps) {
  const [otpValues, setOtpValues] = useState<string[]>(new Array(6).fill(''));
  const [otpType, setOtpType] = useState('sms');
  const [isCountdownActive, setIsCountdownActive] = useState(true);

  const [resetLoading, setResetLoading] = useState(false);
  type TVerfiyPhone = {
    otp: string;
  };

  const navigate = useNavigate();
  const tokenForPhoneOtp = localStorage.getItem('token-for-phone-otp');

  const resetInput = () => {
    setOtpValues(new Array(6).fill(''));
  };
  const loginToken = localStorage.getItem('login-token');
  const tokenToUse = loginToken ? loginToken : tokenForPhoneOtp;
  const details: any = loginToken && jwtDecode(loginToken);

  const disabled = useMemo(() => {
    return otpValues.some((val) => val === '');
  }, [otpValues]);

  const onRedial = () => {
    resetInput();
    // clearTimerFn();
    setResetLoading(true);
    Request.get(`/verify/phone-number`, {
      headers: {
        Authorization: `Bearer ${tokenToUse}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    })
      .then((res) => {
        setIsCountdownActive(true);
        logUserOut(res?.status);
        setResetLoading(false);
        const data = decryptJson(res?.data?.data);
        setOtpType(data?.type);
        customToast('otp has been resent successfully', ToastType.success);
      })
      .catch(() => {
        setResetLoading(false);
        registerNetcoreActivity(
          {
            firstName: details?.firstName,
            lastName: details?.lastName,
            emailAddress: details?.email,
            mobileNumber: details?.phoneNumber,
          },
          'phone number not validated ',
        );
        customToast('An error occured while getting the otp', ToastType.error);
      });
  };

  const resendEmailOtp = () => {
    resetInput();
    // clearTimerFn();
    setResetLoading(true);
    Request.post(`/verify/send-login-otp`, encryptData({ email }), {
      headers: {
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    })
      .then((res) => {
        setIsCountdownActive(true);
        logUserOut(res?.status);
        setResetLoading(false);
      })
      .catch(() => setResetLoading(false));
  };

  const onClickResendEmailOtp = () => {
    resendEmailOtp();
  };

  const onClickReset = () => {
    onRedial();
  };

  const signupToken = localStorage.getItem('signup-token');

  const showErrorToastMessage = (errmsg: string) => {
    customToast(errmsg, ToastType.error, '', 6000);
  };

  const showSuccessToastMessage = (message: string) => {
    customToast(message, ToastType.success);
  };
  const { successfulLoginAction } = useOnSuccessfulLogin();

  const phoneNumberFromLogin = localStorage.getItem('login-phone');

  const errorFn = (error: AxiosError<{ message: string }>) => {
    if (error?.response?.data?.message) {
      showErrorToastMessage(error.response.data.message);
    } else {
      showErrorToastMessage('Something went wrong');
    }
  };

  const verifyEmailOtp = useMutation(
    (data: { email: string; otp: string }) =>
      Request.post(`/verify/login-otp`, encryptData(data), {
        headers: {
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: async (data) => {
        resetInput();
        const res = decryptJson(data?.data?.data);
        const token_ = res?.token;
        successfulLoginAction({
          token: token_ ?? '',
          userDetails: res,
          successFn: () => {
            showSuccessToastMessage('Login Successful');
          },
          verifyPhoneFn: () => {
            setShowModal(false);
            showUnverifiedPhoneModal();
          },
        });

        registerNetcoreActivity(
          {
            emailAddress: res?.email,
            firstName: res?.firstName,
            lastName: res?.lastName,
            mobileNumber: res?.phoneNumber,
          },
          'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
        );

        ReactGA.event({
          category: 'Button',
          action: 'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
          label: 'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
          // value: 1
        });
      },
      onError: (error: AxiosError<{ message: string }>) => {
        resetInput();
        handleError({ error, errorFn });
      },
    },
  );

  const { id } = useAppSelector((state) => state.auth.loggedInUserDetails);

  const verifyPhone = useMutation(
    (data: TVerfiyPhone) =>
      Request.post(`/verify/phone-number`, encryptData(data), {
        headers: {
          Authorization: `Bearer ${tokenToUse}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: async (data) => {
        resetInput();
        if (data.data.status === 200) {
          // display success modal
          if (id) {
            navigate('/dashboard');
          } else {
            setShowSuccessModal(true);
          }
        }
        const res = decryptJson(data?.data?.data);
        registerNetcoreActivity(
          {
            emailAddress: res?.email,
            firstName: res?.firstName,
            lastName: res?.lastName,
            mobileNumber: res?.phoneNumber,
          },
          'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
        );

        ReactGA.event({
          category: 'Button',
          action: 'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
          label: 'TBH_SIGN_UP_INPUT_OTP_VERIFICATION_SUCCESSFUL',
          // value: 1
        });
      },
      onError: async (error: AxiosError<{ message: string }>) => {
        resetInput();
        handleError({ error, errorFn });
      },
    },
  );

  const handleVerifyPhoneOtp = (data: TVerfiyPhone) => {
    !disabled && !verifyPhone?.isLoading && verifyPhone.mutate(data);
  };

  const handleVerifyEmailOtp = (data: { email: string; otp: string }) => {
    !disabled && !verifyEmailOtp?.isLoading && verifyEmailOtp.mutate(data);
    //   trackNetcore();
  };

  const getDevice = () => {
    if (email) {
      return email;
    } else if (phoneNumber) {
      return phoneNumber;
    } else {
      return phoneNumberFromLogin;
    }
  };

  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-[10000000] overflow-y-auto'>
            <div className='fixed inset-0 w-full h-full bg-black opacity-40'></div>
            <div className='flex items-center min-h-screen px-6 py-4'>
              <div className='relative p-[1.6em] sm:py-8 sm:px-[5rem] mx-auto bg-white rounded-md shadow-lg'>
                {/* <div className='text-[14px] text-right text-bold text-[red] sm:mr-[-3em] hover:bg-[red] hover:p-2 hover:text-[white]'>x</div> */}
                <div className='sm:mt-[1.5em] max-w-[300px] sm:flex justify-center'>
                  <div className=' text-center sm:text-left'>
                    <p className=' text-[#229698] font-bold text-[18.6356px] font-["Poppins"] leading-[28px]'>
                      {!email ? `Confirm your profile` : `Two Factor Authentication`}
                    </p>
                    <div className='flex justify-center'>
                      <p className='mt-2 text-[12px] leading-[18px] font-normal mb-1 w-[95%]'>
                        {!email
                          ? getOtpText({ phone: getDevice(), type: otpType })
                          : `An email containing otp was sent to `}
                        <br />
                        <span className='text-[#229698] font-bold'>{getDevice()}</span>, kindly type
                        in the OTP in the field below .
                      </p>
                    </div>

                    <div className='mb-3'>
                      <img src={hr} alt='hr.png' />
                    </div>

                    <OtpInput otp={otpValues} setOtp={setOtpValues} />
                    <div>
                      <div className='flex gap-1 justify-center items-center mt-3 text-[12px] leading-[18px] font-["Poppins"] font-normal'>
                        <p className='mt-1'>
                          {!email
                            ? getOtpBottomText({ phone: getDevice(), type: otpType })
                            : `Didn't get an email?`}
                        </p>
                        {!resetLoading ? (
                          !isCountdownActive ? (
                            otpType?.toLowerCase() !== 'sms' ? (
                              <img
                                className='cursor-pointer'
                                src={reload}
                                height={50}
                                width={55}
                                onClick={onClickReset}
                                alt='reset.png'
                              />
                            ) : (
                              <p
                                className='text-[#E0A508] underline font-semibold text-[11px] h-3 cursor-pointer'
                                onClick={() => {
                                  email ? onClickResendEmailOtp() : onClickReset();
                                }}
                              >
                                Resend
                              </p>
                            )
                          ) : null
                        ) : (
                          <div className='text-[#E0A508] font-semibold flex items-end gap-1 text-[10px]'>
                            <ClipLoader color='#E0A508' size={15} loading={resetLoading} />
                            <div className='h-4'>Please wait</div>
                          </div>
                        )}
                      </div>
                      {isCountdownActive && (
                        <Flex
                          gap={'10px'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          fontWeight={600}
                          marginTop={isCountdownActive ? '8px' : '0px'}
                        >
                          <Text fontFamily={'Poppins'} fontSize={'12px'} color={Colors.black}>
                            Request for another otp after:{' '}
                          </Text>
                          <Countdown
                            isCountdownActive={isCountdownActive}
                            setIsCountdownActive={setIsCountdownActive}
                            countdown={90}
                            color={Colors?.green}
                          />
                        </Flex>
                      )}
                    </div>

                    <div className='flex gap-1 justify-center mt-4 mb-16 text-[#229698] text-[12px] font-["Poppins"] leading-[18px] font-normal'>
                      {signupToken && !email && !id && (
                        <Link to={'/set-security-questions'}>
                          <p className='underline'>{`I'll do this later`}</p>
                        </Link>
                      )}
                    </div>

                    <div className='items-center gap-2 mt-3 sm:flex'>
                      <button
                        onClick={() => {
                          if (!(verifyPhone?.isLoading || verifyEmailOtp?.isLoading)) {
                            !email
                              ? handleVerifyPhoneOtp({
                                  otp: CryptoJS.AES.encrypt(otpValues?.join(''), wqkgx).toString(),
                                })
                              : handleVerifyEmailOtp({
                                  otp: CryptoJS.AES.encrypt(otpValues?.join(''), wqkgx).toString(),
                                  email,
                                });
                          }
                        }}
                        className={[
                          disabled ? 'bg-[grey] cursor-not-allowed' : 'bg-[#229698]',
                          'w-56 md:w-72 mt-2 p-2.5 flex-1 text-white outline-none rounded-[6px]',
                        ].join(' ')}
                      >
                        {verifyPhone.isLoading || verifyEmailOtp.isLoading
                          ? 'Verifying account...'
                          : 'Verify Account'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
